import { Modal, Button } from '@hotjar/hotsauce';
import { noop } from '@hotjar/webapp/lib/function';
import { createGlobalModal } from '@hotjar/webapp/features/GlobalModal/createGlobalModal';
import type { GlobalModalProps } from '@hotjar/webapp/features/GlobalModal/createGlobalModal';

export interface DeleteRecordingsModalProps {
  selectedRecordings: number;
  hasSelectedAllRecordings: boolean;
  totalRecordings: number;
}

export function DeleteRecordingsModal({
  selectedRecordings,
  hasSelectedAllRecordings,
  totalRecordings,
  onCancel,
  onSubmit,
}: DeleteRecordingsModalProps & GlobalModalProps<void, void>): JSX.Element {
  const title =
    selectedRecordings === 1
      ? 'Delete recording?'
      : `Delete ${
          hasSelectedAllRecordings ? `all ${totalRecordings}` : selectedRecordings
        } recordings?`;

  const size = 's';

  return (
    <Modal onClose={onSubmit} contentLabel={title} isOpen size={size}>
      <Modal.Header title={title} />
      <Modal.Body>
        <p>Deleting recordings is permanent and cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={() => onCancel()}>
          Cancel
        </Button>
        <Button kind="danger" onClick={() => onSubmit()}>
          Yes, delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export const openDeleteRecordingsModal = createGlobalModal<DeleteRecordingsModalProps, void, void>(
  DeleteRecordingsModal,
);

export const showDeleteRecordingsModal = async (
  selectedRecordings: number,
  hasSelectedAllRecordings: boolean,
  totalRecordings: number,
  onSubmit: () => void,
): Promise<void> =>
  openDeleteRecordingsModal({
    selectedRecordings,
    hasSelectedAllRecordings,
    totalRecordings,
  })
    .then(onSubmit)
    .catch(noop);
